<template>
  <div id="glry">
    <div v-for="item in list">
      <p><b>{{item.NAME}}</b></p>
      <p>
        {{item.SEX}}，{{item.XRZW}}，{{item.PZWH}}，{{item.RXZSJ}}任现职
        <span v-for="jl in item.XGJL" v-if="jl.title!=='无'">；&nbsp{{jl.title}}{{jl.text}}</span>
      </p>
      <div class="margin-b"></div>
    </div>
  </div>
</template>

<script>
  import ajax from '@/common/ajax/ajax'
  export default {
    name: 'glry',
    data () {
      return {
        list: [{xm: '数据读取中'}]
      }
    },
    created: function () {
      ajax.getGlry().then(
        data => {
          this.list = data
        }
      )
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">
  #glry
    span
      margin-left 0
</style>



// WEBPACK FOOTER //
// glry.vue?3660b816